import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Acknowledgement } from './Acknowledgement';
import { ADIDisclaimer } from './ADIDisclaimer';
import { Disclaimer } from './disclaimer';
import NavItem from './NavItemFooter';

function Footer({ showDisclaimer, hideNavItems }) {
    const { contentfulNavigation, avenueBankLogo, instagramLogo, linkedInLogo, facebookLogo } = useStaticQuery(graphql`
        {
            contentfulNavigation(name: { eq: "Footer Navigation" }) {
                name
                items {
                    id
                    title
                    url
                }
            }
            avenueBankLogo: contentfulSiteImages(name: { eq: "Avenue Bank Logo" }) {
                name
                imageFile {
                    publicUrl
                    localFile {
                        publicURL
                        childImageSharp {
                            fixed {
                                src
                            }
                            gatsbyImageData
                        }
                    }
                }
            }
            facebookLogo: contentfulSiteImages(name: { eq: "Facebook Logo" }) {
                name
                imageFile {
                    localFile {
                        publicURL
                        childImageSharp {
                            fixed (width: 16, height: 16, quality: 75) {
                                ...GatsbyImageSharpFixed
                            }
                            gatsbyImageData(layout: FIXED, width: 16, height: 16, quality: 75)
                        }
                    }
                }
            }
            linkedInLogo: contentfulSiteImages(name: { eq: "LinkedIn Logo" }) {
                name
                imageFile {
                    publicUrl
                    localFile {
                        publicURL
                        childImageSharp {
                            fixed (width: 16, height: 16, quality: 75) {
                                ...GatsbyImageSharpFixed
                            }
                            gatsbyImageData(layout: FIXED, width: 16, height: 16, quality: 75)
                        }
                    }
                }
            }
            instagramLogo: contentfulSiteImages(name: { eq: "Instagram Logo" }) {
                name
                imageFile {
                    localFile {
                        publicURL
                        childImageSharp {
                            fixed (width: 16, height: 16, quality: 75) {
                                ...GatsbyImageSharpFixed
                            }
                            gatsbyImageData(layout: FIXED, width: 16, height: 16, quality: 75, formats: [AUTO, WEBP])
                        }
                    }
                }
            }
        }
    `);

    return (
        <div className='relative z-50 min-h-screen bg-avenue-charade-500 md:min-h-0'>
            <div className='container mx-auto h-full px-6 py-10 lg:pt-10'>
                <div className='mb-2 flex flex-col items-center lg:flex-row lg:justify-between'>
                    <div className='mb-5 md:mb-auto'>
                        <GatsbyImage
                            image={avenueBankLogo?.imageFile?.localFile?.childImageSharp?.gatsbyImageData}
                            className='h-15'
                            alt='Avenue Bank Logo'
                        />
                    </div>
                    <div className='relative flex flex-col items-center space-y-2 border-b border-t border-black-400 py-3 text-white md:justify-center lg:ml-10 lg:flex-row lg:space-x-4 lg:space-y-0 lg:border-none lg:py-0 xl:justify-items-end'>
                        {!hideNavItems &&
                            contentfulNavigation?.items?.map(({ id, title, url }) => (
                                <NavItem
                                    key={`footer-nav-${id}`}
                                    title={title}
                                    to={title === 'Home' ? '/' : `/${url}`}
                                />
                            ))}
                        <div className='flex space-x-2 text-white'>
                            <a href='https://au.linkedin.com/company/avenuebank' target='_blank' rel='noreferrer'>
                                <GatsbyImage
                                    image={linkedInLogo?.imageFile?.localFile?.childImageSharp?.gatsbyImageData}
                                    className='h-4 w-4'
                                    alt='LinkedIn Icon'
                                />
                            </a>
                            <a href='https://www.instagram.com/avenue.bank/' target='_blank' rel='noreferrer'>
                                <GatsbyImage
                                    image={instagramLogo?.imageFile?.localFile?.childImageSharp?.gatsbyImageData}
                                    className='h-4 w-4'
                                    alt='Instagram Icon'
                                />
                            </a>
                            <a
                                href='https://www.facebook.com/people/Avenue-Bank/61556723198615/'
                                target='_blank'
                                rel='noreferrer'
                            >
                                <GatsbyImage
                                    image={facebookLogo?.imageFile?.localFile?.childImageSharp?.gatsbyImageData}
                                    className='h-4 w-4'
                                    alt='Facebook Icon'
                                />
                            </a>
                        </div>
                    </div>
                </div>
                <div className='flex flex-col pt-5 lg:flex-row lg:justify-between'>
                    <div>
                        <a href='tel:1300283265' className='text-xl text-avenue-blue-500 lg:mr-5 lg:inline-block'>
                            Call 1300 283 265
                        </a>
                        <div className='text-md text-white lg:inline-block'>Mon to Fri / 9am - 5pm (AEST)</div>
                    </div>
                    <div className='mt-1 text-xs text-black-100 lg:mt-auto'>
                        &copy; Avenue Bank Ltd ABN 24 628 073 085
                    </div>
                </div>
                {showDisclaimer ? <Disclaimer /> : ''}
                <ADIDisclaimer />
                <Acknowledgement />
            </div>
        </div>
    );
}

export default Footer;
